export const en = {
    'be-sure-no-error': "Page doesn't exist",
    info: 'Check if you made a typo or used the wrong keyboard layout'
};
